import { SkMaxPrice, Update, ValidationResult } from '~/Api/User/ProductGroup/SkMaxPrice';

export enum ActionType {
	request = 'SkMaxPrice.request',
	receive = 'SkMaxPrice.receive',
	requestUpdate = 'SkMaxPrice.requestUpdate',
	receiveUpdate = 'SkMaxPrice.receiveUpdate',
	scheduleUpdate = 'SkMaxPrice.scheduleUpdate',
	requestXlsCreate = 'SkMaxPrice.requestXlsCreate',
	receiveXlsCreate = 'SkMaxPrice.receiveXlsCreate',
	prune = 'SkMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	skMaxPrice: SkMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
	update: Update;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	skMaxPrice: SkMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestXlsCreate;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveXlsCreate;
	validationResult: ValidationResult | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| PruneAction;
